import React, { FC, RefObject } from 'react'
import { Direction, REQUEST_CONFIGS_KEYS } from '@services/constants'
import TextInput from '../inputs/text.inputs'
import RadioInput from '../inputs/radio.input'
import {
	classes,
	isGR6_2SectionA,
	isGR6_2SectionB,
	isGR6_2SectionC,
	isGR6_2SectionD,
	isGR6_2SectionE,
	isGR6_2SectionF
} from './__index.utils'
import { CheckboxList, RadioList, SelectList } from '@utils/request'
import * as utilsList from './__index.utils'
import Notification from '@components/ui/notification'
import CheckboxInput from '../inputs/checkbox.input'
import MeasurementInput from '../inputs/measurement.input'
import { joinClasses } from '@utils/styles'

const Step4_2LandDevelopmentWork = ({
	pageAssets,
	pageUtils,
	formInputs,
	errors,
	updateInput,
	onFixError,
	isSummaryStep = false,
	// *******
	updateCheckBoxInput
}) => {
	const {
		whatToDo,
		// ***********************
		typesOfWorkResidentialLand,
		//section A
		areaOfWorkPreparationTerrain,
		areaOfWorkUnitPreparationTerrain,
		//section B
		areaOfWorkRemblaiDeblaiDecontamination,
		areaOfWorkUnitRemblaiDeblaiDecontamination,
		//section C
		isWallAdditionOrRelocationMuret,
		heightWallMuret,
		heightUnitWallMuret,
		lengthWallMuret,
		lengthUnitWallMuret,
		materialExistingWallMuret,
		materialProjectedWallMuret,
		// section D
		isWallAdditionOrRelocationMurSoutenement,
		heightWallMurSoutenement,
		heightUnitWallMurSoutenement,
		lengthWallMurSoutenement,
		lengthUnitWallMurSoutenement,
		materialExistingWallMurSoutenement,
		materialProjectedWallMurSoutenement,
		// section E
		areaOfWorkBandeTampon,
		areaOfWorkUnitBandeTampon,
		// section F
		areaOfWorkAmenagementPaysager,
		areaOfWorkUnitAmenagementPaysager
	} = formInputs

	const checkboxListTypesOfWorkResidentialLand: CheckboxList[] =
		utilsList.checkboxListTypesOfWorkResidentialLand(pageAssets)

	const radioListMeasurementUnit: RadioList[] =
		utilsList.radioListMeasurementUnit(pageAssets)

	const radioListMeasurement2Unit: RadioList[] =
		utilsList.radioListMeasurement2Unit(pageAssets)

	const radioListLandDevAddOrMoving: RadioList[] =
		utilsList.radioListLandDevAddOrMoving(pageAssets)

	return (
		<>
			<CheckboxInput
				name={typesOfWorkResidentialLand.name}
				label={typesOfWorkResidentialLand.label}
				description={typesOfWorkResidentialLand.description}
				value={`${typesOfWorkResidentialLand.value}`}
				list={checkboxListTypesOfWorkResidentialLand}
				onChange={(value) =>
					updateCheckBoxInput(typesOfWorkResidentialLand, value)
				}
				required={typesOfWorkResidentialLand.required}
				hasError={errors.includes(typesOfWorkResidentialLand.name)}
				ref={typesOfWorkResidentialLand.ref as RefObject<HTMLInputElement>}
				errors={errors}
				shouldNotDivide
				hasBackgroundWrapper
				onFixError={onFixError}
				newCheckValue
				isSummaryStep={isSummaryStep}
			/>

			{/*****  Section A= Préparation de terrain et/ou excavation *****/}
			{isGR6_2SectionA(typesOfWorkResidentialLand.value) && (
				<>
					<h6 className={classes.h6}>
						{pageAssets?.request_form_landDevWorkPermit_PreparationTerrain}
					</h6>

					{/* Superficie des travaux */}
					<MeasurementInput
						measurementInput={areaOfWorkPreparationTerrain}
						unitInput={areaOfWorkUnitPreparationTerrain}
						listMeasurementUnit={radioListMeasurement2Unit}
						maxCharacters={12}
						isSummaryStep={isSummaryStep}
						errors={errors}
						onFixError={onFixError}
						updateInput={updateInput}
						hasError={errors?.includes(areaOfWorkPreparationTerrain.name)}
						reducedMargin
					/>
				</>
			)}

			{/*****  Section B= Remblai, déblai ou décontamination du sol *****/}
			{isGR6_2SectionB(typesOfWorkResidentialLand.value) && (
				<>
					<h6 className={classes.h6}>
						{
							pageAssets?.request_form_landDevWorkPermit_RemblaiDeblaiDecontamination
						}
					</h6>

					{/* Superficie des travaux */}
					<MeasurementInput
						measurementInput={areaOfWorkRemblaiDeblaiDecontamination}
						unitInput={areaOfWorkUnitRemblaiDeblaiDecontamination}
						listMeasurementUnit={radioListMeasurement2Unit}
						maxCharacters={12}
						isSummaryStep={isSummaryStep}
						errors={errors}
						onFixError={onFixError}
						updateInput={updateInput}
						hasError={errors?.includes(
							areaOfWorkRemblaiDeblaiDecontamination.name
						)}
						reducedMargin
					/>
				</>
			)}
			{/*****  Section C= Ajout ou déplacement d'un muret *****/}
			{isGR6_2SectionC(typesOfWorkResidentialLand.value) && (
				<>
					<h6 className={classes.h6}>
						{pageAssets?.request_form_landDevWorkPermit_ajoutDeplacementMuret}
					</h6>

					{/* Effectuez-vous l'ajout ou le déplacement d'un muret? */}
					<RadioInput
						name={isWallAdditionOrRelocationMuret.name}
						label={isWallAdditionOrRelocationMuret.label}
						value={isWallAdditionOrRelocationMuret.value}
						list={radioListLandDevAddOrMoving}
						direction={Direction.vertical}
						hasError={errors!.includes(isWallAdditionOrRelocationMuret.name)}
						onChange={(value) =>
							updateInput(isWallAdditionOrRelocationMuret.name, value)
						}
						ref={
							isWallAdditionOrRelocationMuret.ref as RefObject<HTMLInputElement>
						}
						required={isWallAdditionOrRelocationMuret.required}
						hasBackgroundWrapper={true}
						isSummaryStep={isSummaryStep}
					/>

					<div
						className={joinClasses([
							pageUtils.classes.fieldsContainer,
							'fieldsContainer'
						])}
					>
						{/* Hauteur du muret */}
						<MeasurementInput
							measurementInput={heightWallMuret}
							unitInput={heightUnitWallMuret}
							listMeasurementUnit={radioListMeasurementUnit}
							maxCharacters={6}
							isSummaryStep={isSummaryStep}
							errors={errors}
							onFixError={onFixError}
							updateInput={updateInput}
							hasError={errors?.includes(heightWallMuret.name)}
						/>

						{/* Longueur du muret */}
						<MeasurementInput
							measurementInput={lengthWallMuret}
							unitInput={lengthUnitWallMuret}
							listMeasurementUnit={radioListMeasurementUnit}
							maxCharacters={6}
							isSummaryStep={isSummaryStep}
							errors={errors}
							onFixError={onFixError}
							updateInput={updateInput}
							hasError={errors?.includes(lengthWallMuret.name)}
						/>

						{/* Matériau existant */}
						<TextInput
							id={materialExistingWallMuret.name}
							label={materialExistingWallMuret.label}
							value={materialExistingWallMuret.value}
							onChange={(value) =>
								updateInput(materialExistingWallMuret.name, value)
							}
							hasError={errors.includes(materialExistingWallMuret.name)}
							required={materialExistingWallMuret.required}
							ref={materialExistingWallMuret.ref as RefObject<HTMLInputElement>}
							maxCharacters={50}
							isSummaryStep={isSummaryStep}
						/>
						{/* Matériau projeté */}
						<TextInput
							id={materialProjectedWallMuret.name}
							label={materialProjectedWallMuret.label}
							value={materialProjectedWallMuret.value}
							onChange={(value) =>
								updateInput(materialProjectedWallMuret.name, value)
							}
							hasError={errors.includes(materialProjectedWallMuret.name)}
							required={materialProjectedWallMuret.required}
							ref={
								materialProjectedWallMuret.ref as RefObject<HTMLInputElement>
							}
							maxCharacters={50}
							isSummaryStep={isSummaryStep}
						/>
					</div>
				</>
			)}

			{/*****  Section D= Ajout ou déplacement d'un mur de soutènement *****/}
			{isGR6_2SectionD(typesOfWorkResidentialLand.value) && (
				<>
					<h6 className={classes.h6}>
						{
							pageAssets?.request_form_landDevWorkPermit_ajoutDeplacementMurSoutenement
						}
					</h6>

					{!isSummaryStep && (
						<Notification
							text={
								pageAssets?.request_form_landDevWorkPermit_ajoutDeplacementMurSoutenement_notif
							}
							type="info"
							hasHtml
						/>
					)}

					{/* Effectuez-vous l'ajout ou le déplacement d'un muret? */}
					<RadioInput
						name={isWallAdditionOrRelocationMurSoutenement.name}
						label={isWallAdditionOrRelocationMurSoutenement.label}
						value={isWallAdditionOrRelocationMurSoutenement.value}
						list={radioListLandDevAddOrMoving}
						direction={Direction.vertical}
						hasError={errors!.includes(
							isWallAdditionOrRelocationMurSoutenement.name
						)}
						onChange={(value) =>
							updateInput(isWallAdditionOrRelocationMurSoutenement.name, value)
						}
						ref={
							isWallAdditionOrRelocationMurSoutenement.ref as RefObject<HTMLInputElement>
						}
						required={isWallAdditionOrRelocationMurSoutenement.required}
						hasBackgroundWrapper={true}
						isSummaryStep={isSummaryStep}
					/>

					<div
						className={joinClasses([
							pageUtils.classes.fieldsContainer,
							'fieldsContainer'
						])}
					>
						{/* Hauteur du mur de soutènement */}
						<MeasurementInput
							measurementInput={heightWallMurSoutenement}
							unitInput={heightUnitWallMurSoutenement}
							listMeasurementUnit={radioListMeasurementUnit}
							maxCharacters={6}
							isSummaryStep={isSummaryStep}
							errors={errors}
							onFixError={onFixError}
							updateInput={updateInput}
							hasError={errors?.includes(heightWallMurSoutenement.name)}
						/>

						{/* Longueur du mur de soutènement */}
						<MeasurementInput
							measurementInput={lengthWallMurSoutenement}
							unitInput={lengthUnitWallMurSoutenement}
							listMeasurementUnit={radioListMeasurementUnit}
							maxCharacters={6}
							isSummaryStep={isSummaryStep}
							errors={errors}
							onFixError={onFixError}
							updateInput={updateInput}
							hasError={errors?.includes(lengthWallMurSoutenement.name)}
						/>

						{/* Matériau existant */}
						<TextInput
							id={materialExistingWallMurSoutenement.name}
							label={materialExistingWallMurSoutenement.label}
							value={materialExistingWallMurSoutenement.value}
							onChange={(value) =>
								updateInput(materialExistingWallMurSoutenement.name, value)
							}
							hasError={errors.includes(
								materialExistingWallMurSoutenement.name
							)}
							required={materialExistingWallMurSoutenement.required}
							ref={
								materialExistingWallMurSoutenement.ref as RefObject<HTMLInputElement>
							}
							maxCharacters={50}
							isSummaryStep={isSummaryStep}
						/>
						{/* Matériau projeté */}
						<TextInput
							id={materialProjectedWallMurSoutenement.name}
							label={materialProjectedWallMurSoutenement.label}
							value={materialProjectedWallMurSoutenement.value}
							onChange={(value) =>
								updateInput(materialProjectedWallMurSoutenement.name, value)
							}
							hasError={errors.includes(
								materialProjectedWallMurSoutenement.name
							)}
							required={materialProjectedWallMurSoutenement.required}
							ref={
								materialProjectedWallMurSoutenement.ref as RefObject<HTMLInputElement>
							}
							maxCharacters={50}
							isSummaryStep={isSummaryStep}
						/>
					</div>
				</>
			)}

			{/*****  Section E= Bande tampon *****/}
			{isGR6_2SectionE(typesOfWorkResidentialLand.value) && (
				<>
					<h6 className={classes.h6}>
						{pageAssets?.request_form_landDevWorkPermit_bandeTampon}
					</h6>

					{/* Superficie des travaux */}
					<MeasurementInput
						measurementInput={areaOfWorkBandeTampon}
						unitInput={areaOfWorkUnitBandeTampon}
						listMeasurementUnit={radioListMeasurement2Unit}
						maxCharacters={12}
						isSummaryStep={isSummaryStep}
						errors={errors}
						onFixError={onFixError}
						updateInput={updateInput}
						hasError={errors?.includes(areaOfWorkBandeTampon.name)}
						reducedMargin
					/>
				</>
			)}

			{/*****  Section F= Aménagement paysager et/ou gazonnement *****/}
			{isGR6_2SectionF(typesOfWorkResidentialLand.value) && (
				<>
					<h6 className={classes.h6}>
						{
							pageAssets?.request_form_landDevWorkPermit_amenagementPaysagerGazonnement
						}
					</h6>

					{/* Superficie des travaux */}
					<MeasurementInput
						measurementInput={areaOfWorkAmenagementPaysager}
						unitInput={areaOfWorkUnitAmenagementPaysager}
						listMeasurementUnit={radioListMeasurement2Unit}
						maxCharacters={12}
						isSummaryStep={isSummaryStep}
						errors={errors}
						onFixError={onFixError}
						updateInput={updateInput}
						hasError={errors?.includes(areaOfWorkAmenagementPaysager.name)}
						reducedMargin
					/>
				</>
			)}
		</>
	)
}

export default Step4_2LandDevelopmentWork
